module.exports = __webpack_public_path__ + "images/cc61eeba9b5da2853afacef5d2e6294b.png";